import Typography from "@material-ui/core/Typography/Typography";
import React, {Fragment} from "react";
import {withStyles} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PhoneInput from "material-ui-phone-number";

import styles from "../styles";

class MeinProfil extends React.Component {
  state = {
    isLoaded: false,
    items: {
      id: "Test-ID",
      Vorname: "Test-Vorname",
      Nachname: "Test-Nachname",
      TelefonNummer: "+492222",
      EmailAdresse: "Test-Email",
      Test2: "Test2",
    },
  };

  componentDidMount() {
    this.getDataFromApi();
  }

  getDataFromApi = () => {
    fetch(`${process.env.REACT_APP_API_URL}/v1/userdata/${this.props.userId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: false,
            error: error,
          });
        }
      );
  };

  handleChange = (name) => ({ target: { value } }) => {
    this.setState({
      items: {
        ...this.state.items,
        [name]: value,
      },
    });
  };

  handleSubmit = () => {
    // TODO: Validate

    const { items } = this.state;

    fetch(`${process.env.REACT_APP_API_URL}/v1/userdata/${this.props.userId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: items["id"],
        Vorname: items["Vorname"],
        Nachname: items["Nachname"],
        TelefonNummer: items["TelefonNummer"],
        EmailAdresse: items["EmailAdresse"],
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: false,
            error: error,
          });
        }
      );
    console.log(this.state);
  };

  render() {
    const { classes } = this.props;
    const { isLoaded, items } = this.state;

    return (
      <Fragment>
        <div className={classes.appBarSpacer} />
        <Typography variant="h4" gutterBottom component="h2">
          Nutzerdaten
        </Typography>
        {isLoaded ? (
          <Fragment>
            <Typography component="ul" className={classes.userData}>
              <li>ID: {items["id"]}</li>
              <li>Vorname: {items["Vorname"]}</li>
              <li>Nachname: {items["Nachname"]}</li>
              <li>Telefonnummer: {items["TelefonNummer"]}</li>
              <li>Email: {items["EmailAdresse"]}</li>
            </Typography>
            <form className={classes.container} noValidate autoComplete="off">
              <div>
                <TextField
                  disabled
                  id="edit-user-id"
                  label="ID"
                  className={classes.textField}
                  value={items["id"]}
                  onChange={this.handleChange("id")}
                  margin="normal"
                />

                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      label="Vorname"
                      name="vorname"
                      autoComplete="fname"
                      id="edit-user-vorname"
                      className={classes.textField}
                      value={items["Vorname"]}
                      onChange={this.handleChange("Vorname")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="nachname"
                      autoComplete="lname"
                      id="edit-user-nachname"
                      label="Nachname"
                      className={classes.textField}
                      value={items["Nachname"]}
                      onChange={this.handleChange("Nachname")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <PhoneInput
                      variant="outlined"
                      fullWidth
                      disableAreaCodes
                      defaultCountry="de"
                      name="TelefonNummer"
                      value={items["TelefonNummer"]}
                      //    onChange={this.handleChange("TelefonNummer")}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="email"
                      label="Email Adresse"
                      name="EmailAdresse"
                      value={items["EmailAdresse"]}
                      autoComplete="email"
                      onChange={this.handleChange("EmailAdresse")}
                    />
                  </Grid>
                </Grid>
              </div>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.handleSubmit}
              >
                Speichern
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={this.getDataFromApi}
              >
                Abbrechen
              </Button>
            </form>
          </Fragment>
        ) : (
          <Typography variant="h5" gutterBottom component="h2">
            <CircularProgress className={classes.progress} />
          </Typography>
        )}
      </Fragment>
    );
  }
}

export default withStyles(styles)(MeinProfil);
